export default __webpack_public_path__ + "1ff29458b94ba677607899eaf4205b03.png";